import { render } from "./MathJsonAnswerField.vue?vue&type=template&id=6c1d241f&ts=true"
import script from "./MathJsonAnswerField.vue?vue&type=script&lang=ts"
export * from "./MathJsonAnswerField.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__